/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * ScheduleActionIgnoredFeaturesDtoBase
 * auto generated base class for the model ScheduleActionIgnoredFeaturesDtoModel.
 */
export const ScheduleActionIgnoredFeaturesDtoModelBase = ModelBase
  .named('ScheduleActionIgnoredFeaturesDto')
  .props({
    __typename: types.optional(types.literal("ScheduleActionIgnoredFeaturesDto"), "ScheduleActionIgnoredFeaturesDto"),
    has_capacities: types.union(types.undefined, types.boolean),
    has_balance: types.union(types.undefined, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ScheduleActionIgnoredFeaturesDtoModelSelector extends QueryBuilder {
  get has_capacities() { return this.__attr(`has_capacities`) }
  get has_balance() { return this.__attr(`has_balance`) }
}
export function selectFromScheduleActionIgnoredFeaturesDto() {
  return new ScheduleActionIgnoredFeaturesDtoModelSelector()
}

export const scheduleActionIgnoredFeaturesDtoModelPrimitives = selectFromScheduleActionIgnoredFeaturesDto().has_capacities.has_balance
